"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _toObject = _interopRequireDefault(require("./toObject"));

var _pipe = _interopRequireDefault(require("./util/pipe"));

var _default = (0, _unmutable.default)({
  name: 'mergeWith',
  immutable: 'mergeWith',
  object: function object(merger) {
    for (var _len = arguments.length, newValues = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      newValues[_key - 1] = arguments[_key];
    }

    return _pipe.default.apply(void 0, (0, _toConsumableArray2.default)(newValues.map((0, _pipe.default)((0, _toObject.default)(), function (newValue) {
      return function (value) {
        var clonedValue = (0, _objectSpread2.default)({}, value);
        Object.keys(newValue).forEach(function (key) {
          clonedValue[key] = key in clonedValue ? merger(clonedValue[key], newValue[key], key) : newValue[key];
        });
        return clonedValue;
      };
    }))));
  }
});

exports.default = _default;